import type { AdminFeatureKey } from './adminFeatures'
import type { AdminActionKey } from './adminActions'

export type AdminRouteMatrixRouteRow = {
  kind: 'route'
  title: string
  path: string
  feature: AdminFeatureKey
}

export type AdminRouteMatrixActionRow = {
  kind: 'action'
  title: string
  path: string
  action: AdminActionKey
}

export type AdminRouteMatrixRow = AdminRouteMatrixRouteRow | AdminRouteMatrixActionRow

/** Single matrix for the role editor: titles and paths match the product route matrix. */
export const ADMIN_ROUTE_MATRIX: AdminRouteMatrixRow[] = [
  { kind: 'route', title: 'Opportunity List', path: '/opportunities', feature: 'opportunities' },
  { kind: 'route', title: 'Add Opportunity', path: 'opportunities/new', feature: 'opportunities' },
  {
    kind: 'route',
    title: 'Edit Opportunity',
    path: 'opportunities/opportunity-slug/opportunity-id/edit',
    feature: 'opportunities',
  },
  { kind: 'route', title: 'Coming soon List', path: '/coming-soon', feature: 'comingSoon' },
  { kind: 'route', title: 'Add Coming soon', path: '/coming-soon/new', feature: 'comingSoon' },
  { kind: 'route', title: 'Edit Coming soon', path: '/coming-soon/id/edit', feature: 'comingSoon' },
  { kind: 'route', title: 'Order List', path: '/orders', feature: 'orders' },
  { kind: 'route', title: 'Wallet Top-ups', path: '/wallet/topups', feature: 'investments' },
  { kind: 'route', title: 'Stock trading', path: '/trading', feature: 'investments' },
  {
    kind: 'route',
    title: 'Wallet Withdrawals',
    path: '/wallet/withdrawals',
    feature: 'withdrawals',
  },
  {
    kind: 'route',
    title: 'Allocation Requests',
    path: '/allocation-requests',
    feature: 'opportunities',
  },
  {
    kind: 'route',
    title: 'Allocation Request Detail',
    path: '/allocation-requests/id',
    feature: 'opportunities',
  },
  {
    kind: 'route',
    title: 'Allocation Requests',
    path: '/allocation-requests',
    feature: 'opportunities',
  },
  {
    kind: 'route',
    title: 'Allocation Request Detail',
    path: '/allocation-requests/id',
    feature: 'opportunities',
  },
  {
    kind: 'route',
    title: 'Investment Limit Requests',
    path: '/investment-limit-requests',
    feature: 'kyc',
  },
  {
    kind: 'route',
    title: 'Investment Limit Request Detail',
    path: '/investment-limit-requests/id',
    feature: 'kyc',
  },
  {
    kind: 'route',
    title: 'View Order Details (Investment)',
    path: 'opportunity/opportunity-slug/opportunity-id/client/investor-id/investment/detail/investment-id',
    feature: 'investments',
  },
  {
    kind: 'route',
    title: 'View Order Details (Withdrawal)',
    path: 'opportunity/opportunity-slug/opportunity-id/client/investor-id/withdrawal/detail/withdrawal-id',
    feature: 'withdrawals',
  },
  {
    kind: 'action',
    title: 'Update Order (Investment)',
    path: '—',
    action: 'updateInvestmentOrderStatus',
  },
  {
    kind: 'action',
    title: 'Update Order (Withdrawal)',
    path: '—',
    action: 'updateOrderWithdrawalStatus',
  },
  { kind: 'route', title: 'Client List', path: '/clients', feature: 'investors' },
  {
    kind: 'action',
    title: 'Update Investment Limit',
    path: '—',
    action: 'updateInvestmentLimit',
  },
  {
    kind: 'route',
    title: 'Investment List',
    path: 'user/investments/investor-id',
    feature: 'investments',
  },
  {
    kind: 'route',
    title: 'Withdrawal List',
    path: '/user/withdrawals/investor-id',
    feature: 'withdrawals',
  },
  {
    kind: 'route',
    title: 'Client Profile',
    path: 'client/investor-id/profile',
    feature: 'investors',
  },
  { kind: 'action', title: 'Block Client', path: '—', action: 'blockInvestor' },
  {
    kind: 'action',
    title: 'Resend verification link',
    path: '—',
    action: 'resendVerificationLink',
  },
  {
    kind: 'action',
    title: 'Add Opportunity Terms',
    path: '—',
    action: 'addInvestorOpportunityTerms',
  },
  { kind: 'route', title: 'Inquiry List', path: '/inquiries', feature: 'inquiries' },
  {
    kind: 'route',
    title: 'Interest Payout',
    path: '/interest-payouts',
    feature: 'interestPayouts',
  },
  {
    kind: 'route',
    title: 'Dividend Payout',
    path: '/dividend-payouts',
    feature: 'dividendPayouts',
  },
  { kind: 'route', title: 'Blog List', path: '/blogs', feature: 'blogs' },
  { kind: 'route', title: 'Add Blog', path: '/blogs/new', feature: 'blogs' },
  { kind: 'route', title: 'Edit Blog', path: '/blogs/id/edit', feature: 'blogs' },
  { kind: 'route', title: 'FAQ List', path: '/faqs', feature: 'faqs' },
  { kind: 'route', title: 'Add FAQ', path: '/faqs/new', feature: 'faqs' },
  { kind: 'route', title: 'Edit FAQ', path: '/faqs/id/edit', feature: 'faqs' },
  {
    kind: 'route',
    title: 'Opportunity FAQs',
    path: '/faqs/opportunity-questions',
    feature: 'opportunities',
  },
  {
    kind: 'route',
    title: 'Answer or edit opportunity FAQ',
    path: '/faqs/opportunity-questions/id/reply',
    feature: 'opportunities',
  },
  {
    kind: 'route',
    title: 'Newsletter Subscriber List',
    path: '/newsletter/subscribers',
    feature: 'newsletter',
  },
  {
    kind: 'route',
    title: 'Newsletter groups',
    path: '/newsletter/groups',
    feature: 'newsletter',
  },
  {
    kind: 'route',
    title: 'Add Newsletter group',
    path: '/newsletter/groups/new',
    feature: 'newsletter',
  },
  { kind: 'route', title: 'Send newsletter', path: '/newsletter/send', feature: 'newsletter' },
  {
    kind: 'route',
    title: 'Edit Newsletter group',
    path: '/newsletter/groups/id/edit',
    feature: 'newsletter',
  },
  {
    kind: 'route',
    title: 'News list',
    path: '/news',
    feature: 'opportunities',
  },
  {
    kind: 'route',
    title: 'News fetch schedule',
    path: '/news/schedule',
    feature: 'adminTeam',
  },
  {
    kind: 'route',
    title: 'General Unit Price',
    path: '/unit-prices?type=general',
    feature: 'unitPrices',
  },
  {
    kind: 'route',
    title: 'Client Unit Price',
    path: '/unit-prices?type=client',
    feature: 'unitPrices',
  },
  { kind: 'route', title: 'Campaign List', path: '/campaigns', feature: 'campaigns' },
  { kind: 'route', title: 'Create Campaign', path: '/campaigns/new', feature: 'campaigns' },
  { kind: 'route', title: 'Edit Campaign', path: '/campaigns/id/edit', feature: 'campaigns' },
]

const routeRows = ADMIN_ROUTE_MATRIX.filter(
  (r): r is AdminRouteMatrixRouteRow => r.kind === 'route',
)

/** Features that appear in the route matrix (for bulk read/write/none in the role editor). */
export const ADMIN_ROUTE_MATRIX_FEATURE_KEYS: AdminFeatureKey[] = [
  ...new Set(routeRows.map((r) => r.feature)),
]

/** Actions that appear in the route matrix (for bulk allow/deny in the role editor). */
export const ADMIN_ROUTE_MATRIX_ACTION_KEYS: AdminActionKey[] = ADMIN_ROUTE_MATRIX.filter(
  (r): r is AdminRouteMatrixActionRow => r.kind === 'action',
).map((r) => r.action)
